import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { Catalogo } from '../../../../../interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { EntidadesKeys } from 'src/app/enum/entidades-keys.enum';
import { SignoLocalidad } from 'src/app/interfaces/interface-bakend/entidades/signo-localidad.interface';
import { SignoLocalidadService } from 'src/app/services/entidades/signo-localidades.service';
import { CatalogoService } from 'src/app/services/shared/catalogo.service';
// Importar el servicio de provincias
import { ProvinciaService } from '@services/provincias/provincias.service';
import { Provincia } from '@interfaces/interface-bakend/provincias/provincias.interface';

@Component({
  selector: 'app-localidad-alta',
  templateUrl: './localidad-alta.component.html',
  styleUrls: ['./localidad-alta.component.scss']
})
export class LocalidadAltaComponent implements OnInit {

  form: FormGroup;
  catalogo: Catalogo;
  zonas: Catalogo[];
  provincias: Provincia[]; // Nueva propiedad para almacenar provincias

  constructor(
    private router: Router,
    private signoLocalidadesService: SignoLocalidadService,
    private catalogoService: CatalogoService,
    private provinciaService: ProvinciaService, // Inyectar el servicio de provincias
    public guiMsjService: GuiMsjService,
  ) {
      this.createForm();
      this.getZonas();
      this.getProvincias(); // Llamar al método para obtener provincias
   }

  ngOnInit(): void {
  }

  get localidadNoValida(){
    return this.form.get('localidad').invalid && this.form.get('localidad').touched;
  }

  get zonaNoseleccionada() {
    return (
      this.form.get('zona').invalid &&
      this.form.get('zona').touched
    );
  }

  // Nuevo getter para validación de provincia
  get provinciaNoSeleccionada() {
    return (
      this.form.get('provincia').invalid &&
      this.form.get('provincia').touched
    );
  }

  async getZonas() {
    this.zonas = await this.catalogoService.findDescendantsByKey(EntidadesKeys.ZONAS);
  }

  // Método para obtener las provincias
  async getProvincias() {
    this.provincias = await this.provinciaService.findAll();
  }

  createForm() {
    this.form = new FormGroup({
        localidad: new FormControl('', [ Validators.required, Validators.min(3)]),
        zona: new FormControl('', [ Validators.required]),
        provincia: new FormControl('', [ Validators.required]), // Nuevo FormControl para provincia
        activa: new FormControl(true, [ Validators.required]),
    });
  }

  async setDataForma(): Promise<SignoLocalidad>{
    const data: SignoLocalidad = {
      nombre: this.form.value.localidad.trim(),
      activo: this.form.value.activa,
      zona: {
        _id: this.form.value.zona
      },
      provincia: {
      _id: this.form.value.provincia
      },
    };
    return data;
  }

  async post(){
    await this.guiMsjService.msjFormSubmit('Guardando');
    await this.signoLocalidadesService.create(await this.setDataForma()).then(()=>{
      this.router.navigateByUrl('/localidades-listado');
    }).catch((error) => {
      console.error('Error al guardar localidad', error);
    });
  }
}